import { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import ActivityLogService from '@/services/ActivityLogService';
import { ActivityLogStoreInterface } from '@/types/ActivityLog';

export default defineStore('ActivityLogStore', {
  state: (): ActivityLogStoreInterface => {
    return {
      error: undefined,
      loading: false,
      logs: [],
      filters: {
        start_at: '',
        end_at: '',
        search: '',
      },
      currentPage: 0,
      oldFilters: '',
      meta: {
        to: 0,
        total: 0,
      },
    };
  },

  getters: {
    userLogs: (state) => state.logs,
  },

  actions: {
    catchError(e: AxiosResponse) {
      this.error = e.data.message;
      this.loading = false;
      throw e;
    },

    loaded() {
      this.loading = false;
      this.error = undefined;
    },

    setOldFilters() {
      this.oldFilters = `${this.filters.start_at}-${this.filters.end_at}-${this.filters.search}`;
    },

    getFiltersHash() {
      return `${this.filters.start_at}-${this.filters.end_at}-${this.filters.search}`;
    },

    restorePaginationState(force?: boolean) {
      if (force || this.getFiltersHash() !== this.oldFilters) {
        this.currentPage = 0;
        this.logs = [];
        this.filters.per_page = 50;
      }

      this.setOldFilters();
    },

    async getLogs(userId: number) {
      this.restorePaginationState();

      if (this.currentPage === -1 || this.loading) return;

      this.loading = true;
      this.error = undefined;
      this.currentPage++;

      const sendFilter = { ...this.filters };

      if (this.filters.person_id) sendFilter.search = '';

      const response = await ActivityLogService.getLogs(userId, sendFilter, this.currentPage);

      if (response) {
        if (response.data.meta.current_page === response.data.meta.last_page) this.currentPage = -1;
        this.logs = !this.logs.length ? response.data.data : this.logs.concat(response.data.data);
        this.meta = {
          to: response.data.meta.to,
          total: response.data.meta.total,
        };
      }

      this.loaded();
    },
  },
});
